/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SingleLineStringTagSuggestionList } from '../../models/single-line-string-tag-suggestion-list';

export interface TagGetSingleLineStringTagSuggestionList$Params {

/**
 * GUID of the tag
 */
  tagId: string;

/**
 * Search text
 */
  searchText?: string;

/**
 * Requested offset in found suggestions
 */
  offset?: number;

/**
 * Requested suggestion item count. Value must be less than or equal to 255
 */
  count?: number;
}

export function tagGetSingleLineStringTagSuggestionList(http: HttpClient, rootUrl: string, params: TagGetSingleLineStringTagSuggestionList$Params, context?: HttpContext): Observable<StrictHttpResponse<SingleLineStringTagSuggestionList>> {
  const rb = new RequestBuilder(rootUrl, tagGetSingleLineStringTagSuggestionList.PATH, 'get');
  if (params) {
    rb.path('tagId', params.tagId, {});
    rb.query('searchText', params.searchText, {});
    rb.query('offset', params.offset, {});
    rb.query('count', params.count, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SingleLineStringTagSuggestionList>;
    })
  );
}

tagGetSingleLineStringTagSuggestionList.PATH = '/tag/single-line-string/{tagId}/suggestion/list';
